/** All calendar dates and times are stored and displayed in Thailand time,
 * regardless of the viewer's own locale or timezone. */
export const THAI_TIME_ZONE = 'Asia/Bangkok';

export const DAY_MS = 86_400_000;

/** The Thai calendar date an instant falls on, `YYYY-MM-DD` (en-CA only for its ISO shape; never shown). */
export function thaiDay(date = new Date()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: THAI_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

/** The instants a run of Thai calendar days covers: midnight on `from` up to midnight after `through`. */
export function thaiDayRange(from: string, through: string) {
  const start = new Date(`${from}T00:00:00+07:00`);
  const end = new Date(new Date(`${through}T00:00:00+07:00`).getTime() + DAY_MS);
  return { from: start.toISOString(), to: end.toISOString() };
}

/** How many calendar days `YYYY-MM-DD` dates span, counting both ends; null when either is not a date. */
export function spanDays(from: string, to: string) {
  const start = Date.parse(`${from}T00:00:00Z`);
  const end = Date.parse(`${to}T00:00:00Z`);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return null;
  return Math.round((end - start) / DAY_MS) + 1;
}
